export const TURNSTILE_STAGING_SITE_KEY = '0x4AAAAAAAFIVRgDLKmxZX82';
export const TURNSTILE_PRODUCTION_SITE_KEY = '0x4AAAAAAAFIUlKyH502xmcr';
// Cloudflare's always-pass test sitekey. It renders on any hostname, and
// Hire's sandbox verifies its tokens with the matching test secret
// (.rwx/packages/hire/fakes.json).
export const TURNSTILE_TEST_SITE_KEY = '1x00000000000000000000AA';
